export default {
  origins: {
    loading: false,
    lastUpdate: null,
    data: [],
  },
}
